import { Listing } from "@/lib/types";
import PropertyAmenitiesSection from "./PropertyAmenitiesSection";
import PropertyDescriptionSection from "./PropertyDescriptionSection";
import PropertyDetailsSection from "./PropertyDetailsSection";

interface PropertyMainContentProps {
  property: Listing;
}

const PropertyMainContent = ({ property }: PropertyMainContentProps) => {
  return (
    <div className="lg:col-span-2 space-y-6">
      {/* Property Description */}
      <PropertyDescriptionSection description={property.description} />

      {/* Amenities Section */}
      {property.attributes &&
        property.attributes.filter((attr) => attr.type === "amenity").length >
          0 && <PropertyAmenitiesSection amenities={property.attributes} />}

      {/* Property Details */}
      <PropertyDetailsSection
        property={property}
        features={property.attributes || []}
      />
    </div>
  );
};

export default PropertyMainContent;
